export const insiderGalleryVariant = (imageCount: number): number =>
  Math.min(Math.max(imageCount, 1), 4);
